import React, { useState, useEffect} from "react";
import axios from "axios";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { useNavigate } from 'react-router-dom';

const EditProduct = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const productID = urlParams.get('id');
    const navigate = useNavigate();
	const [product, setproduct] = useState([]);
    const [formData, setFormData] = useState({
        code: '',
        name: '',
        price: '',
        id: productID,  // Set productID as the initial id
    });
    //console.log(formData);

    // Fetching Data
    useEffect(() => {
        // Make the API call
        axios.get("https://api.trucoo.in/product/allproduct/")
            .then(response => {
                if(response.data.status === "success") {
                    // console.log(response.data);
                    const filteredData = response.data.data.filter(product => product.id === productID);

                    // Check if filteredData is not empty and set the formData state correctly
                    if (filteredData.length > 0) {
                        const productDetails = filteredData[0]; // Assuming you want the first match
                        setFormData({
                            code: productDetails.productCode,
                            name: productDetails.productName,
                            price: productDetails.productPrice,
                            hsn: productDetails.productHsn,
                            gst: productDetails.productGst,
                            id: productID,
                            weight: productDetails.productWeight,
                            unit: productDetails.unit,
                            crates: productDetails.grade,
                            type: productDetails.type,
                        });
                    } else {
                        console.warn("No product found with that ID");
                    }

                    // Optionally, you can set the full product data to the state, if needed
                    setproduct(response.data);

                    // You can log the filtered data for debugging
                    //console.log(filteredData);
                } else {
                    console.error(response.data);
                }
            })
            .catch(error => {
                console.error("There was an error in fetching data", error);
            });
    }, [productID]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        

        //console.log("Form Submitted: ", formData);

        // Fetch functionality
        axios.post('https://api.trucoo.in/product/editproduct/', formData, {

            headers: {
                'Content-Type': 'application/json'
            }

        })
            .then(response => {
                if (response.data.status === "success") {
                       window.location = `/product`;
                  } else {
                    console.error(response.data);
                  }

            })
            .catch(error => {
                console.error("There was an Error");
            });

        // console.log('Form Data:', formData);

    }
    return(

        <>
        <Header />
        <Sidebar />


        <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
				<div class="box box-body">
					<div class="row">
                       
					<div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="box">
							    <div class="box-body">

								    <h4 class="box-title text-primary mb-0"><i class="ti-user me-15"></i>Edit Product</h4>
								    <hr class="my-15" />

								    <div class="row">

								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Product Code</label>
									            <input type="text" class="form-control" name="code" value={formData.code} onChange={handleChange}/>
									        </div>
								        </div>

								        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Product Name</label>
									            <input type="text" class="form-control" name="name" value={formData.name} onChange={handleChange}/>
									        </div>
								        </div>

                                        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Product Type</label>
									            <select class="form-select" name="type" value={formData.type} onChange={handleChange} >
													<option value="" hidden>Select Type</option>
													<option value="milk">MILK</option>
													<option value="curd">CURD</option>
													<option value="buttermilk">BUTTER MILK</option>
													<option value="ghee">GHEE</option>
													<option value="butter">BUTTER</option>
													<option value="paneer">PANEER</option>
													<option value="cream">CREAM</option>
												</select>
									        </div>
								        </div>

										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Price/Packet</label>
									            <input type="number" class="form-control" name="price" value={formData.price} onChange={handleChange} />
											
									        </div>
								        </div>
										
										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">HSN Code</label>
									            <input type="number" class="form-control" name="hsn" value={formData.hsn} onChange={handleChange} />
											
									        </div>
								        </div>
										
										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">GST%</label>
									            <input type="number" class="form-control" name="gst" value={formData.gst} onChange={handleChange} />
											
									        </div>
								        </div>

                                        <div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Packets/Crate</label>
									            <input type="number" class="form-control" name="crates" value={formData.crates} onChange={handleChange} />
									        </div>
								        </div>

										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Weight ML/GM</label>
									            <input type="number" class="form-control" name="weight" value={formData.weight} onChange={handleChange} />
									        </div>
								        </div>

										<div class="col-md-3">
									        <div class="form-group">
									            <label class="form-label">Unit</label>
									            <select class="form-select" name="unit" value={formData.unit} onChange={handleChange} >
													<option value="" hidden>Select Unit</option>
													<option value="L">L</option>
													<option value="KG">Kg</option>
												</select>
									        </div>
								        </div>

										<div class="col-md-12 mt-4" align="center">
									        <div class="form-group">
									            <button type="submit" class="btn btn-primary" onClick={handleSubmit}><i class="ti-save-alt"></i> Update</button>
									        </div>
								        </div>
									

                                       

								    </div>
                        
                                </div>
                            </div>
                        </div>
                     
					</div>
				</div>
			</section>
		</div>
	</div>


        </>
    )

    
}

export default EditProduct;